// Dependencies
import React from 'react';
import radium from 'radium';
import {ThemeContext} from "../../../components/theme/Theme.jsx";

function ShoppingCartTotal(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			textAlign: 'center',
			margin: '3em 0',
			padding: '3em 0',
			borderTop: '1px solid' + context.themeManager.value('event-total-info',
				'borderColor', 'separator-color'),
			borderBottom: '1px solid' + context.themeManager.value('event-total-info',
				'borderColor', 'separator-color'),
			backgroundColor: context.themeManager.value('event-total-info',
				'bgColor', 'bg-color-box')
		},
		total: {
			fontSize: context.themeManager.value('event-total', 'fontSize', 'font-size-400'),
			fontWeight: '600',
		},
		info: {
			fontSize: context.themeManager.value('event-total-info',
				'fontSize', 'font-size-80'),
			lineHeight: context.themeManager.value('event-total-info',
				'lineHeight', 'line-height-200'),
		},
	};

	return (
		<div className="subtotal__container" style={style.container}>
			<span style={style.total}>Zu Zahlen {parseFloat(props.total).toFixed(2)} €</span>
			<br />
			<span style={style.info}>{context.themeManager.getCheckoutPriceLegalNoteOrDefault()}</span>
		</div>
	);
}

export default radium(ShoppingCartTotal);
